import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';
import { notifyPermissionDenied } from '../core/handleCallableError';

export const getMyOffers = async () => {
  const getOffersFn = httpsCallable(functions, 'getMyActiveOffersV2');

  try {
    const result = await getOffersFn();
    return result.data;
  } catch (error) {
    console.error('Error al obtener las ofertas:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};

export const getMyOffersReload = async (lastVisible, limit, winningFilter) => {
  const data = { lastVisible, limit, winningFilter, pagedBids: winningFilter !== true };
  
  const getOffersFn = httpsCallable(functions, 'getMyOffersReloadableNewV2');
  try {
    const result = await getOffersFn(data);
    return result.data;
  } catch (error) {
    console.error('Error al obtener las ofertas:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};

export const getMyOfferUpdates = async (auctionIds) => {
  try {
    const result = await httpsCallable(functions, 'getMyOffersReloadableNewV2')({ auctionIds });
    if (result.data?.updatesOnly !== true) throw new Error('El servidor requiere recargar el historial completo.');
    return result.data;
  } catch (error) {
    notifyPermissionDenied(error);
    throw error;
  }
};
